import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ['Pulling into the lot and still not knowing what you’re running today', 'Twelve players in a line while one takes a ground ball', 'A practice-plan spreadsheet you started in week one and never finished', 'A drill that flew last week falls flat with this group', 'Volunteering with no softball background and feeling exposed in front of the team', 'Parents on the fence line, wondering if you know what you’re doing', 'Scrolling YouTube at 10pm for drills you can actually teach', 'A rainout, a late field or half the team missing — and no plan B'];
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="w-full bg-navy-deep" data-id="element-204" data-mp="1brnvrsas2sn1">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-205" data-mp="17qc4zjg641d9">
        <div className="text-center" data-id="element-206" data-mp="362khgqavx9kb">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-207" data-mp="361j5mjm1oj1j">
            The coaching reality
          </p>
          <h2 id="pain-heading" className="chalk-underline mt-3 font-display font-bold uppercase text-white text-4xl sm:text-5xl leading-tight" data-id="element-208" data-mp="3g8k2ndk0qcpk">
            If you coach softball, you know at least{' '}
            <span className="text-clay-soft" data-id="element-209" data-mp="379zsj0sixbcy">half of this list.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-3 text-left sm:grid-cols-2 sm:gap-x-5" data-id="element-210" data-mp="3baikqvybwjfo">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-xl border border-navy-line bg-navy-card px-4 py-4 text-sm text-white/85" data-id="element-211" data-mp="2uytu3l4rd3s">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-crimson/25" data-id="element-212" data-mp="3q6rift2kmopz">
                <XIcon className="h-3 w-3 text-crimson-soft" aria-hidden="true" data-id="element-213" data-mp="3u6rwhclrcxwi" />
              </span>
              {pain}
            </li>)}
        </ul>

        <p className="chalk-note mt-9 text-center text-3xl sm:text-4xl text-gold leading-tight" data-id="element-214" data-mp="10frqs2lwq0w5">
          How many more practices do you want to improvise?
        </p>
      </div>
    </section>;
}